var _circle, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 94,
    cy: 94,
    r: 94,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.927 98.9203H130.487C137.301 96.1447 139.824 87.5645 135.786 83.5267C132.506 80.2458 126.702 81.0029 122.412 85.2934C120.141 87.5645 119.131 92.1068 118.627 95.6395C118.123 92.1068 117.113 87.5645 114.842 85.2934C110.804 81.2555 104.747 80.2467 101.467 83.5267C97.4296 87.5645 99.9533 96.1439 106.767 98.9203H86.0738C84.3071 98.9203 82.793 100.434 82.793 102.201V106.491C82.793 108.258 84.3071 109.772 86.0738 109.772H87.5879V145.353C87.5879 147.371 89.3546 149.138 91.3732 149.138H116.103V98.9199H121.149V149.138H145.879C147.898 149.138 149.664 147.371 149.664 145.353L149.665 109.772H151.179C152.946 109.772 154.46 108.258 154.46 106.491V102.453C154.207 100.434 152.693 98.9203 150.927 98.9203H150.927ZM103.233 89.3313C103.233 88.5742 102.981 87.0601 103.99 86.0504C105.504 84.789 109.037 84.5363 112.065 87.8172C113.579 89.3313 114.589 93.3692 115.093 97.1544C109.542 96.6492 103.739 95.1351 103.233 89.3313ZM124.937 88.0698C128.218 84.789 131.75 85.0416 133.012 86.3031C134.526 87.8172 134.273 91.6024 131.245 94.378C129.731 95.8921 125.693 96.9018 121.908 97.4062C122.413 93.6209 123.423 89.5839 124.937 88.0698Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5408 113.81C79.7653 112.548 77.7459 109.772 77.7459 106.239V102.202C77.7459 97.6592 81.5311 93.874 86.0734 93.874H95.6624C93.6439 88.8272 94.401 83.5279 97.9336 79.9944C102.98 74.9477 111.308 75.7047 117.364 81.0041L115.598 66.1157C115.346 63.0875 112.823 60.8164 109.795 60.8164H96.6721V54.0029C96.6721 49.4606 94.9054 45.4227 91.8772 42.3945C88.849 39.3663 84.8111 37.5996 80.2688 37.5996C71.1842 37.5996 63.8663 44.9175 63.8663 54.0021V60.8155L47.2112 60.8164C44.183 60.8164 41.6592 63.0875 41.4075 66.1157L33.0799 143.839C32.8273 147.371 35.3511 150.4 38.8837 150.4H84.0536C83.0439 148.886 82.5395 147.371 82.5395 145.605L82.5408 113.81ZM68.9139 54.0029C68.9139 47.6939 73.9606 42.6472 80.2697 42.6472C86.5787 42.6472 91.6254 47.6939 91.6254 54.0029V60.8164H68.6609V54.0029H68.9139Z",
    fill: "#1A1A1A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.9297,
    y: 29.5977,
    width: 5.18621,
    height: 188,
    transform: "rotate(-45 25.9297 29.5977)",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTickets);
export default __webpack_public_path__ + "static/media/no_tickets.b82e5905f2fa8e8cc6df43866486058c.svg";
export { ForwardRef as ReactComponent };